import React from "react";
import PropTypes from "prop-types";
import { SimpleSelect } from "components/common/select";

export const DocumentTypeSelector = ({ onChange }) => (
  <div>
    <span>Document Type</span>
    <SimpleSelect
      data={ options }
      onChange={ onChange }
      placeholder="Select a document type..."
    />
  </div>
);

DocumentTypeSelector.propTypes = {
  onChange: PropTypes.func.isRequired
};

const options = [
  { key: "receipt", name: "Receipt" },
  { key: "other", name: "Other document" }
];




// WEBPACK FOOTER //
// ./src/js/components/documents/filters/document-type-selector.jsx